import React from 'react'
import { useRandomId } from '@fs/zion-frontend-friends'

export default function FaceFeature({ scaleX, gradient, skinOutline, fill, outline, secondaryFill, secondaryOutline }) {
  const randomGradientId1 = `_${useRandomId()}`

  return (
    <g transform={`scale(${scaleX},1)`}>
      <path
        d="M73.0007 40.9699C73.0007 40.9699 59.4407 34.0799 55.3907 29.3499C50.8907 24.0899 51.0907 1.44995 51.0907 1.44995H38.6707C38.6707 1.44995 38.9807 24.1999 34.3707 29.3499C29.4807 34.8099 16.7607 40.77 16.7607 40.77C22.9507 55.35 35.3507 59.0699 44.8807 59.0699C54.4207 59.0699 66.8107 55.5499 73.0007 40.9699Z"
        fill={`url(#${randomGradientId1})`}
        stroke={skinOutline}
        strokeWidth="2"
        strokeMiterlimit="10"
      />
      <path
        d="M86.5308 57.8699C84.9708 45.8599 81.3208 42.6199 76.6508 40.2699C74.3508 39.1099 59.8308 31.3899 59.8308 31.3899C59.8308 31.3899 54.9208 38.3299 45.2408 38.3299C35.5608 38.3299 29.9408 31.3899 29.9408 31.3899C29.9408 31.3899 15.5008 39.0599 13.1008 40.2699C8.43077 42.6199 4.87076 46.2499 3.22076 57.8699C1.74076 68.9299 1.30078 71.6899 1.30078 71.6899H88.4508C88.4508 71.6799 87.8408 68.1599 86.5308 57.8699Z"
        fill={fill}
        stroke={outline}
        strokeWidth="2"
        strokeMiterlimit="10"
      />
      <path
        d="M23.9912 34.2C23.9912 34.2 30.2412 44.4399 43.9712 44.4399C59.1612 44.4399 65.7712 34.2 65.7712 34.2"
        stroke={outline}
        strokeWidth="0.75"
        strokeMiterlimit="10"
        fill="none"
      />
      <path
        d="M68.7803 56.4399H20.9803L18.2803 71.9699H71.4803L68.7803 56.4399Z"
        fill={secondaryFill}
        stroke={secondaryOutline}
        strokeWidth="2"
        strokeMiterlimit="10"
      />
      <path
        d="M32.1902 56.3501C32.1902 56.3501 33.0802 57.6301 32.7402 58.2701C32.4002 58.9101 31.3902 58.7601 31.0602 59.1601C30.7302 59.5601 31.4802 60.6101 30.5502 61.1101C29.6202 61.6101 29.1802 60.3901 28.6602 60.4301C28.1402 60.4801 27.7502 61.3701 27.0302 61.2901C26.3102 61.2101 25.7002 59.7801 25.7002 59.7801L32.1902 56.3501Z"
        stroke="white"
        fill="none"
        strokeWidth="0.7"
        strokeMiterlimit="10"
        strokeLinejoin="round"
      />
      <path
        d="M31.9904 56.97L26.3504 59.96L14.6504 38L20.2804 35.01L31.9904 56.97Z"
        fill={secondaryFill}
        stroke={secondaryOutline}
        strokeMiterlimit="10"
        strokeLinejoin="round"
      />
      <path
        d="M25.3269 42.8736L18.377 46.5654L20.2018 50.0007L27.1518 46.3089L25.3269 42.8736Z"
        stroke="white"
        fill="none"
        strokeWidth="0.7"
        strokeMiterlimit="10"
        strokeLinejoin="round"
      />
      <path
        d="M30.1007 61.8601C31.0009 61.8601 31.7307 61.1303 31.7307 60.2301C31.7307 59.3299 31.0009 58.6001 30.1007 58.6001C29.2005 58.6001 28.4707 59.3299 28.4707 60.2301C28.4707 61.1303 29.2005 61.8601 30.1007 61.8601Z"
        fill="white"
      />
      <path
        d="M57.5708 56.3501C57.5708 56.3501 56.6808 57.6301 57.0208 58.2701C57.3608 58.9101 58.3708 58.7601 58.7008 59.1601C59.0308 59.5601 58.2808 60.6101 59.2108 61.1101C60.1408 61.6001 60.5808 60.3901 61.1008 60.4301C61.6208 60.4801 62.0108 61.3701 62.7308 61.2901C63.4508 61.2101 64.0608 59.7801 64.0608 59.7801L57.5708 56.3501Z"
        stroke="white"
        fill="none"
        strokeWidth="0.7"
        strokeMiterlimit="10"
        strokeLinejoin="round"
      />
      <path
        d="M57.7705 56.97L63.4005 59.96L75.1105 38L69.4805 35.01L57.7705 56.97Z"
        fill={secondaryFill}
        stroke={secondaryOutline}
        strokeMiterlimit="10"
        strokeLinejoin="round"
      />
      <path
        d="M62.5852 46.3365L69.5352 50.0283L71.36 46.593L64.41 42.9012L62.5852 46.3365Z"
        stroke="white"
        fill="none"
        strokeWidth="0.7"
        strokeMiterlimit="10"
        strokeLinejoin="round"
      />
      <path
        d="M59.6505 61.8601C60.5507 61.8601 61.2805 61.1303 61.2805 60.2301C61.2805 59.3299 60.5507 58.6001 59.6505 58.6001C58.7503 58.6001 58.0205 59.3299 58.0205 60.2301C58.0205 61.1303 58.7503 61.8601 59.6505 61.8601Z"
        fill="white"
      />
      <defs>
        <linearGradient
          id={randomGradientId1}
          x1="44.8787"
          y1="42.6205"
          x2="44.8787"
          y2="8.58785"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.1476" stopColor={gradient[1]} />
          <stop offset="0.8447" stopColor={gradient[0]} />
        </linearGradient>
      </defs>
    </g>
  )
}
